import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Services from "./pages/Services";
import ProjectTypes from "./pages/ProjectTypes";
import CoreStrengths from "./pages/CoreStrengths";
import Compliance from "./pages/Compliance";
import Contact from "./pages/Contact";
import Projects from "./pages/Projects";
import Gallery from "./pages/Gallery";
import CompanyProfile from "./pages/CompanyProfile";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/services" element={<Services />} />
            <Route path="/project-types" element={<ProjectTypes />} />
            <Route path="/core-strengths" element={<CoreStrengths />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/company-profile" element={<CompanyProfile />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
